module.exports = __webpack_public_path__ + "img/alert-white.e46a727a.svg";